import {Calendar} from '@fullcalendar/core';
import dayGridPlugin from '@fullcalendar/daygrid';
import interactionPlugin from '@fullcalendar/interaction';
import tippy from 'tippy.js';
import 'tippy.js/dist/tippy.css';

//calendario de la agenda (Full calendar)
document.addEventListener('DOMContentLoaded', function () {
    var calendarEl = document.getElementById('agenda-calendar');

    var calendar = new Calendar(calendarEl, {
        contentHeight: 'auto',
        plugins: [dayGridPlugin, interactionPlugin],
        initialView: 'dayGridMonth',
        firstDay: 1,
        selectable: true,
        headerToolbar: {
            left: '', // Dejamos vacío, insertaremos el select manualmente
            right: 'prev,next',
        },
        //Tooltip de eventos
        eventDidMount: function (info) {
            tippy(info.el, {
                content: info.event.title, // El contenido es el título del evento
                theme: 'calendar__home', // Usar el tema personalizado
                placement: 'top', // Posicionar el tooltip arriba del evento
                arrow: true, // Mostrar una flecha en el tooltip
                delay: [300, 300],
            });
        },
        events: events,
        dayMaxEventRows: 1,
        datesSet: function () {
            createMonthSelect(calendar); // Llama a la función cada vez que se actualizan las fechas
        },
        moreLinkContent: function (args) {
            // Cambiar el texto "more" por "más" en español
            return '+' + args.num + ' más';
        },
        moreLinkClassNames: "color-primary",
        dateClick: function (info) {
            // Llamar a la función AJAX con la fecha seleccionada
            cambiarFechaSeleccionada(info.dateStr);
        }
    });
    calendar.setOption('locale', 'es');
    calendar.render();

    // Función para crear el select de meses y manejar el cambio de mes
    function createMonthSelect(calendar) {
        var currentMonth = calendar.getDate().getMonth();
        var currentYear = calendar.getDate().getFullYear(); // Obtener el año actual
        var select = document.createElement('select');

        // Arreglo de meses con el año actual
        var months = [
            {value: 0, name: 'Enero ' + currentYear},
            {value: 1, name: 'Febrero ' + currentYear},
            {value: 2, name: 'Marzo ' + currentYear},
            {value: 3, name: 'Abril ' + currentYear},
            {value: 4, name: 'Mayo ' + currentYear},
            {value: 5, name: 'Junio ' + currentYear},
            {value: 6, name: 'Julio ' + currentYear},
            {value: 7, name: 'Agosto ' + currentYear},
            {value: 8, name: 'Septiembre ' + currentYear},
            {value: 9, name: 'Octubre ' + currentYear},
            {value: 10, name: 'Noviembre ' + currentYear},
            {value: 11, name: 'Diciembre ' + currentYear}
        ];

        // Limpiar cualquier select existente antes de crear uno nuevo
        var toolbarLeft = document.querySelector('.fc-toolbar-chunk:nth-child(1)');
        toolbarLeft.innerHTML = ''; // Limpiamos la parte izquierda de la toolbar

        // Agregar las opciones al select
        months.forEach(function (month) {
            var option = document.createElement('option');
            option.value = month.value;
            option.textContent = month.name;
            if (month.value === currentMonth) {
                option.selected = true; // Selecciona el mes actual
            }
            select.appendChild(option);
        });

        // Cuando el usuario selecciona un nuevo mes
        select.addEventListener('change', function (e) {
            var selectedMonth = parseInt(e.target.value);
            var currentDate = calendar.getDate();
            calendar.gotoDate(new Date(currentDate.getFullYear(), selectedMonth, 1));
        });

        // Añadir el select en la toolbar izquierda
        toolbarLeft.appendChild(select);
    }

    function cambiarFechaSeleccionada(fechaSeleccionada) {
        fetch(`/actualizar-fecha-seleccionada`, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                'X-CSRF-TOKEN': document.querySelector('meta[name="csrf-token"]').getAttribute('content')
            },
            body: JSON.stringify({
                fecha: fechaSeleccionada
            })
        })
            .then(response => response.json())
            .then(data => {
                if (data.success) {
                    // Aquí puedes actualizar el DOM con la nueva fecha si lo deseas
                    let [ano, mes, dia] = fechaSeleccionada.split("-");
                    let fecha = `${dia}/${mes}/${ano}`;
                    document.getElementById("fechaSeleccionada").innerText = `${fecha}`;
                    // Recargar solo el contenido de agenda
                    cargarAgenda();
                } else {
                    alert('Hubo un error al actualizar la fecha');
                }
            })
            .catch(error => {
                console.error('Error:', error);
                alert('No se pudo actualizar la fecha');
            });
    }

    function cargarAgenda() {
        fetch(`/obtener-agenda`, {
            method: 'GET',
            headers: {
                'X-CSRF-TOKEN': document.querySelector('meta[name="csrf-token"]').getAttribute('content')
            }
        })
            .then(response => response.text())
            .then(html => {
                document.querySelector(".section4__agenda-list").innerHTML = html;
            })
            .catch(error => console.error('Error:', error));
    }
});
